import { useNavigate } from 'react-router';
import { ExpenseForm } from '@/components/ExpenseForm';
import { useAuth } from '@/context/AuthContext';
import { useRepositories } from '@/context/RepositoryContext';
import { invalidateExpenses } from '@/hooks/expensesStore';

export function NewExpenseManualRoute() {
  const { user } = useAuth();
  const { expenseRepository } = useRepositories();
  const navigate = useNavigate();

  return (
    <ExpenseForm
      mode="create"
      onCancel={() => navigate('/expenses')}
      onSubmit={async (data) => {
        if (!user) throw new Error('You must be signed in.');
        await expenseRepository.createExpense({
          user_id: user.uid,
          transaction_date: data.transaction_date,
          store_name: data.store_name || null,
          items: data.items,
          subtotal: data.subtotal,
          tax: data.tax,
          discount: data.discount ?? 0,
          total: data.total,
          status: data.status || 'pending',
          notes: data.notes || null,
          receipt_url: null,
        });
        invalidateExpenses();
        navigate('/expenses');
      }}
    />
  );
}
